import React, { useEffect, useMemo, useState } from "react";
import { useShowModal } from "../../../hooks";
import { Header, Wrapper, CardWrapper } from "./style";
import Button from "../../../components/FormElement/Button";
import { PlusOutlined } from "@ant-design/icons";
import Form from "./Form";
import SliderCard from "../../../components/Cards/SliderCard";
import CustomPagination from "../../../components/FormElement/Pagination";
import DeleteModal from "../../../components/DeleteModal";
import { useHideModal } from "../../../hooks";
import service from "../../../services/slider";
import { useShowAlert } from "../../../hooks/useAlerts";
import Spinner from "../../../components/Spinner/FullScreen";

function Dashboard() {
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);

  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : " "),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}`,
    [pageQuery, limitQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result.rows.map((item, idx) => ({
        ...item,
        img: item.photo,
        idx: idx + 1,
        index: pagination.page * pagination.limit - pagination.limit + idx + 1,
      }));
      setData(finalResult);
      setTotal(result.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [query]);

  const handleShowModal = () => {
    showBlured({
      title: "Slayder qo'shish",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form refreshData={fetchData} />,
    });
  };

  const handleUpdate = (data) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form data={data?.id} refreshData={fetchData} />,
    });
  };

  const onDelete = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    showBlured({
      title: "",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <DeleteModal onClick={() => onDelete(id)} />,
    });
  };

  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };

  if (loading) return <Spinner />;
  return (
    <Wrapper>
      <Header>
        <Button
          text="Qo'shish"
          icon={<PlusOutlined />}
          onClick={handleShowModal}
        />
      </Header>
      <CardWrapper>
        {data.map((item) => {
          return (
            <SliderCard
              key={item.idx}
              data={item}
              handleUpdate={handleUpdate}
              handleDelete={handleDelete}
            />
          );
        })}
      </CardWrapper>

      {total > 10 && (
        <CustomPagination
          align="end"
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </Wrapper>
  );
}

export default Dashboard;
